import axios from 'axios'

export function requesURLResetPassword(email){
  return axios.post(`${ process.env.API_URL }/v1/users/password`, { email: email })
}

export function updateNewPassword(params) {
  var params = {
    user: {
      email: params['email'],
      password: params['password']
    },
    reset_password_token: params['reset_password_token']
  }
  return axios.post(`${ process.env.API_URL }/v1/users/reset`, params)
}

export function validateUrlResetPassword(params) {
  return axios.get(`${ process.env.API_URL }/v1/users/password/valid_token`, { params: params })
}



// WEBPACK FOOTER //
// ./src/backend/recoverPassword.js